export enum ShareType {
    'VIEW' = 0,
    'EDIT' = 1
}